module.exports = __webpack_public_path__ + "static/media/mellow_mood_hotels.c664bbec.png";